var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOlivegroupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.675,
    height: 19.286,
    viewBox: "0 0 76.675 19.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OliveGroup_Black-CYMK",
    transform: "translate(0.014 0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M269.552,196.37l-.012,3.729,11.521.036.012-3.728-7.483-.024Z",
    transform: "translate(-247.596 -181.274)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3071",
    "data-name": "Rectangle 3071",
    width: 3.728,
    height: 8.189,
    transform: "translate(68.414 18.97) rotate(-89.828)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3072",
    "data-name": "Rectangle 3072",
    width: 9.166,
    height: 4.039,
    transform: "translate(36.196 9.704) rotate(-89.828)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3073",
    "data-name": "Rectangle 3073",
    width: 9.166,
    height: 4.039,
    transform: "translate(36.167 18.869) rotate(-89.828)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3074",
    "data-name": "Rectangle 3074",
    width: 14.603,
    height: 4.039,
    transform: "translate(21.897 15.07) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M513.661,30.713,509.37,30.7l7.162,18.353h0l4.292.013Z",
    transform: "translate(-466.385 -30.139)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3075",
    "data-name": "Rectangle 3075",
    width: 3.728,
    height: 7.735,
    transform: "translate(68.212 11.49) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3076",
    "data-name": "Rectangle 3076",
    width: 3.728,
    height: 8.189,
    transform: "translate(68.462 4.369) rotate(-89.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M753.643,31.47l-.023,7.145,4.038.013.011-3.418.012-3.728Z",
    transform: "translate(-689.205 -30.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M753.21,124.1l4.039.013.011-3.728.012-3.729.011-3.728-4.04-.013Z",
    transform: "translate(-688.831 -105.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M628.63,46.885l6.326-15.912-4.291-.013L626.5,41.432Z",
    transform: "translate(-573.238 -30.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M24.236,37.159A5.778,5.778,0,0,1,32.3,29.1l2.743-2.743A9.629,9.629,0,0,0,21.491,39.9Z",
    transform: "translate(-19.329 -24.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M70.674,67.749a5.778,5.778,0,0,1-8.045,8.043l-2.751,2.751A9.629,9.629,0,0,0,73.425,65Z",
    transform: "translate(-56.329 -61.43)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlivegroupLogo);
export default __webpack_public_path__ + "static/media/olivegroup-logo.0c36edf86b111ccb641fcad12b381e9e.svg";
export { ForwardRef as ReactComponent };